import client from './client';
import { getUserId, getAuthCode } from './authStorage';

export async function fetchReports() {
  const user_id = getUserId();
  const auth_code = getAuthCode();

  const payload = { user_id, auth_code };
  const { data: res } = await client.post('/fetch_reports.php', payload);

  if (res.status !== 200) throw new Error(res.message || 'Failed to fetch reports');
  return res.data;
}
